import React, { useContext } from "react"
import Row from "./Row"
import ShareButtons from "./ShareButtons"
import { Shelter } from "../types/shelter"
import { PCViewContext } from "../Common/PCViewContext"

import * as styles from "./Styles/ResultSet.module.scss"
import classNames from "classnames/bind"
import Loader from "../Common/Loader"
const cn = classNames.bind(styles)

const ResultSet: React.FC<{
  count: number
  shelters: Array<Shelter>
  showLoader: boolean
  url: string
}> = ({ count, shelters, showLoader, url }) => {
  const isPC = useContext(PCViewContext)
  return (
    <div className={cn("container", isPC ? "container--pc" : "container--sp")}>
      {url && (
        <React.Fragment>
          <div className={styles.externalLink}>
            <a href={url} target="_blank">
              避難に関する最新の情報はこちら
            </a>
          </div>
          <hr className={styles.border} />
        </React.Fragment>
      )}
      <div className={styles.count}>
        <span className={styles.resultNum}>{count}</span>
        <span className={styles.resultNote}>件</span>
      </div>
      <hr className={styles.border} />
      <div className={cn("results", showLoader ? "results--showLoader" : "")}>
        <Loader show={showLoader} color="green" small={false} />
        {shelters.map((shelter, i) => (
          <React.Fragment key={i}>
            <Row shelter={shelter} />
            {i < shelters.length && <hr className={styles.border} />}
          </React.Fragment>
        ))}
      </div>
      <div>
        <ShareButtons />
      </div>
    </div>
  )
}
export default ResultSet
